module.exports = __webpack_public_path__ + "img/alfie-afi-afi.eb3155eb.jpeg";